import React, { useState, useEffect } from "react";
import { 
  ShoppingBag, 
  X, 
  Plus, 
  Minus, 
  Trash2, 
  Heart, 
  Search, 
  Sparkles, 
  Check, 
  MapPin, 
  CreditCard, 
  Lock, 
  Mail, 
  Star, 
  Menu, 
  Sun, 
  Moon, 
  Maximize2, 
  Sliders, 
  ShieldCheck, 
  Activity, 
  Award,
  ChevronRight,
  Info
} from "lucide-react";
import { Toaster, toast } from "./components/ui/sonner";
import "@/App.css";

// -------------------------------------------------------------
// STATIC CUSTOM CATALOG PRODUCTS
// -------------------------------------------------------------
const CATALOG_PRODUCTS = [
  {
    id: "bag-01",
    title: "L'Élégance Noir Tote",
    category: "Architectural Tote",
    price: 2850,
    rating: 4.9,
    url: "https://images.unsplash.com/photo-1590739225287-bd31519780c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBoYW5kYmFnJTIwZWRpdG9yaWFsJTIwbW9kZWx8ZW58MHx8fHwxNzkxNzgyNjc5fDA&ixlib=rb-4.1.0&q=85",
    description: "Hand-stitched Italian full-grain calfskin tote with polished brass accents. Features a spacious interior lined with plush suede, dual top handles, and a structured, architectural silhouette that commands presence.",
    dimensions: "14.5\" W x 11.2\" H x 6.5\" D",
    weight: "2.4 lbs",
    materials: "100% Full-grain Calfskin, solid solid brass hardware."
  },
  {
    id: "bag-02",
    title: "Monolith Saddle Clutch",
    category: "Crossbody & Clutch",
    price: 1920,
    rating: 5.0,
    url: "https://images.unsplash.com/photo-1683921470299-b8f0f3331657?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBoYW5kYmFnJTIwZWRpdG9yaWFsJTIwbW9kZWx8ZW58MHx8fHwxNzkxNzgyNjc5fDA&ixlib=rb-4.1.0&q=85",
    description: "Minimalist structured gray calfskin flap bag with custom key-lock hardware. Designed to transition seamlessly from a tailored daytime crossbody to an elegant evening statement clutch.",
    dimensions: "9.8\" W x 6.5\" H x 3.2\" D",
    weight: "1.2 lbs",
    materials: "Box calfskin leather, hand-polished key lock clochette."
  },
  {
    id: "bag-03",
    title: "Aura Cognac Duffle",
    category: "Weekend & Travel",
    price: 3400,
    rating: 4.8,
    url: "https://images.unsplash.com/photo-1597633125184-9fd7e54f0ff7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBoYW5kYmFnJTIwZWRpdG9yaWFsJTIwbW9kZWx8ZW58MHx8fHwxNzkxNzgyNjc5fDA&ixlib=rb-4.1.0&q=85",
    description: "Vegetable-tanned cognac leather satchel featuring botanical edge coat finish. Offers substantial capacity for short travels without compromising on sophisticated Florentine luxury.",
    dimensions: "18.5\" W x 12.0\" H x 9.5\" D",
    weight: "3.6 lbs",
    materials: "Vegetable-tanned leather, heavy cotton twill lining, brass feet."
  },
  {
    id: "bag-04",
    title: "Prism Azure Micro Bag",
    category: "Limited Edition AI",
    price: 2200,
    rating: 4.9,
    url: "https://images.unsplash.com/photo-1652427019217-3ded1a356f10?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBoYW5kYmFnJTIwZWRpdG9yaWFsJTIwbW9kZWx8ZW58MHx8fHwxNzkxNzgyNjc5fDA&ixlib=rb-4.1.0&q=85",
    description: "Sculptural teal azure top-handle bag generated via AI aesthetic algorithm and crafted entirely by hand by a senior artisan in limited single-batch runs.",
    dimensions: "7.0\" W x 5.5\" H x 2.8\" D",
    weight: "0.8 lbs",
    materials: "Glazed drum-dyed calfskin, micro-brushed aluminum accent plates."
  },
  {
    id: "bag-05",
    title: "Sovereignty Metallic Chain Satchel",
    category: "Evening Couture",
    price: 3150,
    rating: 5.0,
    url: "https://images.unsplash.com/photo-1589363358751-ab05797e5629?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxsZWF0aGVyJTIwbHV4dXJ5JTIwaGFuZGJhZyUyMHByb2R1Y3R8ZW58MHx8fHwxNzkxNzgyNjc4fDA&ixlib=rb-4.1.0&q=85",
    description: "Refined platinum metallic grain leather with custom diamond-cut curb chain shoulder strap. Perfect for high-fashion soirées, weddings, and formal gala occurrences.",
    dimensions: "10.5\" W x 7.0\" H x 3.5\" D",
    weight: "1.5 lbs",
    materials: "Metallic metallic foil-coated leather, custom rhodium hardware."
  },
  {
    id: "bag-06",
    title: "Velvet Crimson Flap",
    category: "Crossbody & Clutch",
    price: 2600,
    rating: 4.9,
    url: "https://images.unsplash.com/photo-1591348278900-019a8a2a8b1d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHw0fHxsZWF0aGVyJTIwbHV4dXJ5JTIwaGFuZGJhZyUyMHByb2R1Y3R8ZW58MHx8fHwxNzkxNzgyNjc4fDA&ixlib=rb-4.1.0&q=85",
    description: "Deep crimson quilted chevron leather with a burnished gold monogram clasp. Embodies architectural symmetry and high-society romance in every millimeter of stitch.",
    dimensions: "11.0\" W x 7.5\" H x 4.0\" D",
    weight: "1.7 lbs",
    materials: "Chevron quilted lambskin, genuine gold-plated lock clasp."
  }
];

const CATEGORIES = ["All", "Architectural Tote", "Crossbody & Clutch", "Weekend & Travel", "Evening Couture", "Limited Edition AI"];

export default function App() {
  // -------------------------------------------------------------
  // STATE MANAGEMENT
  // -------------------------------------------------------------
  const [theme, setTheme] = useState(() => localStorage.getItem("theme") || "dark");
  const [cart, setCart] = useState([]);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [sortBy, setSortBy] = useState("default");
  
  // Quick View State
  const [quickViewBag, setQuickViewBag] = useState(null);
  const [quickViewStitching, setQuickViewStitching] = useState("Champagne Gold");
  const [quickViewStrap, setQuickViewStrap] = useState("Classic Leather Handle");

  // Bespoke Customizer State
  const [customLeather, setCustomLeather] = useState("Pebbled Calfskin");
  const [customHardware, setCustomHardware] = useState("Polished Brass");
  const [customLining, setCustomLining] = useState("Ruby Velvet");
  const [customMonogram, setCustomMonogram] = useState("");
  const [isCustomizing, setIsCustomizing] = useState(false);

  // Bag Finder Quiz State
  const [quizArchetype, setQuizArchetype] = useState(null);
  const [suggestedBag, setSuggestedBag] = useState(null);

  // VIP Club Newsletter State
  const [newsletterEmail, setNewsletterEmail] = useState("");
  const [newsletterSuccess, setNewsletterSuccess] = useState(false);

  // Checkout Simulation State
  const [isCheckoutOpen, setIsCheckoutOpen] = useState(false);
  const [checkoutStep, setCheckoutStep] = useState(1); // 1 = form, 2 = loading, 3 = confirmation
  const [checkoutLoadingText, setCheckoutLoadingText] = useState("");
  const [checkoutData, setCheckoutData] = useState({
    name: "",
    email: "",
    address: "",
    cardNum: "",
    expiry: "",
    cvv: ""
  });
  const [promoCode, setPromoCode] = useState("");
  const [appliedDiscount, setAppliedDiscount] = useState(0); // 0 to 1
  const [checkoutErrors, setCheckoutDataErrors] = useState({});

  // -------------------------------------------------------------
  // THEME EFFECT
  // -------------------------------------------------------------
  useEffect(() => {
    const root = document.documentElement;
    if (theme === "light") {
      root.classList.add("light");
      root.classList.remove("dark");
    } else {
      root.classList.add("dark");
      root.classList.remove("light");
    }
    localStorage.setItem("theme", theme);
  }, [theme]);

  // Toggle Theme
  const toggleTheme = () => {
    setTheme(prev => (prev === "dark" ? "light" : "dark"));
    toast.success(`Switched to ${theme === "dark" ? "Light" : "Dark"} Mode`);
  };

  // -------------------------------------------------------------
  // CART ACTIONS
  // -------------------------------------------------------------
  const addToCart = (bag, customization = null) => {
    const itemKey = customization 
      ? `${bag.id}-${customization.leather}-${customization.hardware}-${customization.lining}-${customization.monogram}`
      : bag.id;

    setCart(prevCart => {
      const existingIndex = prevCart.findIndex(item => item.cartKey === itemKey);
      if (existingIndex > -1) {
        const updated = [...prevCart];
        updated[existingIndex].quantity += 1;
        toast.success(`Increased quantity of ${bag.title} in cart`);
        return updated;
      } else {
        toast.success(`Added ${bag.title} to your private atelier cart`);
        return [...prevCart, {
          ...bag,
          cartKey: itemKey,
          quantity: 1,
          customization
        }];
      }
    });
  };

  const updateQuantity = (cartKey, amount) => {
    setCart(prevCart => {
      return prevCart.map(item => {
        if (item.cartKey === cartKey) {
          const newQty = item.quantity + amount;
          return newQty > 0 ? { ...item, quantity: newQty } : item;
        }
        return item;
      }).filter(item => item.quantity > 0);
    });
  };

  const removeFromCart = (cartKey, title) => {
    setCart(prevCart => prevCart.filter(item => item.cartKey !== cartKey));
    toast.info(`Removed ${title} from cart`);
  };

  // -------------------------------------------------------------
  // CALCULATION HELPER
  // -------------------------------------------------------------
  const getSubtotal = () => {
    return cart.reduce((acc, item) => {
      let price = item.price;
      if (item.customization) {
        if (item.customization.leather === "Crocodile Embossed") price += 450;
        if (item.customization.leather === "Smooth Box Calf") price += 150;
        if (item.customization.hardware === "Rose Gold") price += 100;
        if (item.customization.monogram) price += 50; // extra charge for monogramming
      }
      return acc + (price * item.quantity);
    }, 0);
  };

  const getDiscountedTotal = () => {
    const sub = getSubtotal();
    return sub * (1 - appliedDiscount);
  };

  // Apply Coupon Code
  const handleApplyCoupon = (e) => {
    e.preventDefault();
    if (promoCode.toUpperCase() === "MAISONVIP") {
      setAppliedDiscount(0.15);
      toast.success("VIP coupon applied: 15% discount granted");
    } else if (promoCode.toUpperCase() === "MANGO10") {
      setAppliedDiscount(0.1);
      toast.success("TagMango creator discount: 10% discount granted");
    } else {
      toast.error("Invalid invitation code or discount voucher");
    }
  };

  // -------------------------------------------------------------
  // CUSTOMIZER LOGIC
  // -------------------------------------------------------------
  const getBespokePrice = () => {
    let base = 2500; // Base custom bag price
    if (customLeather === "Crocodile Embossed") base += 450;
    if (customLeather === "Smooth Box Calf") base += 150;
    if (customHardware === "Rose Gold") base += 100;
    if (customMonogram) base += 50;
    return base;
  };

  const handleAddBespokeToCart = () => {
    const customBag = {
      id: "bespoke-bag",
      title: `Bespoke Monogrammed Clutch`,
      category: "Bespoke Couture",
      price: getBespokePrice(),
      url: "https://images.unsplash.com/photo-1682745230951-8a5aa9a474a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxoYW5kYmFnJTIwY3JhZnRzbWFuc2hpcCUyMGF0ZWxpZXJ8ZW58MHx8fHwxNzkxNzgyNjc4fDA&ixlib=rb-4.1.0&q=85",
      description: `Exquisitely crafted custom bag tailored to your aesthetic. Crafted in luxurious ${customLeather} with robust ${customHardware} finishings and an interior lined in ${customLining}.`
    };

    const customization = {
      leather: customLeather,
      hardware: customHardware,
      lining: customLining,
      monogram: customMonogram.toUpperCase()
    };

    addToCart(customBag, customization);
    setIsCartOpen(true);
  };

  // -------------------------------------------------------------
  // QUIZ LOGIC
  // -------------------------------------------------------------
  const handleQuizSelection = (archetype) => {
    setQuizArchetype(archetype);
    let matchedBag = null;
    if (archetype === "Daily Executive") {
      matchedBag = CATALOG_PRODUCTS.find(b => b.id === "bag-01");
    } else if (archetype === "Evening Gala") {
      matchedBag = CATALOG_PRODUCTS.find(b => b.id === "bag-06");
    } else {
      matchedBag = CATALOG_PRODUCTS.find(b => b.id === "bag-03");
    }
    setSuggestedBag(matchedBag);
    toast.success(`Matched style archetype: Perfect bag suggested!`);
  };

  // -------------------------------------------------------------
  // CHECKOUT LOGIC
  // -------------------------------------------------------------
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "cardNum") {
      // Auto-format spaces
      const cleaned = value.replace(/\s+/g, "").replace(/[^0-9]/gi, "");
      const matches = cleaned.match(/\d{4,16}/g);
      const match = (matches && matches[0]) || "";
      const parts = [];

      for (let i = 0, len = match.length; i < len; i += 4) {
        parts.push(match.substring(i, i + 4));
      }

      setCheckoutData(prev => ({
        ...prev,
        cardNum: parts.length > 0 ? parts.join(" ") : cleaned.substring(0, 19)
      }));
    } else if (name === "expiry") {
      // Auto-format expiry MM/YY
      const cleaned = value.replace(/[^0-9]/g, "");
      if (cleaned.length >= 2) {
        setCheckoutData(prev => ({
          ...prev,
          expiry: `${cleaned.slice(0, 2)}/${cleaned.slice(2, 4)}`
        }));
      } else {
        setCheckoutData(prev => ({ ...prev, expiry: cleaned }));
      }
    } else {
      setCheckoutData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleCheckoutSubmit = (e) => {
    e.preventDefault();
    const errors = {};
    if (!checkoutData.name) errors.name = "Full Name is required";
    if (!checkoutData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(checkoutData.email)) {
      errors.email = "A valid Email Address is required";
    }
    if (!checkoutData.address) errors.address = "Delivery address is required";
    if (!checkoutData.cardNum || checkoutData.cardNum.replace(/\s/g, "").length < 16) {
      errors.cardNum = "A valid 16-digit card number is required";
    }
    if (!checkoutData.expiry || checkoutData.expiry.length < 5) {
      errors.expiry = "Expiry date (MM/YY) is required";
    }
    if (!checkoutData.cvv || checkoutData.cvv.length < 3) {
      errors.cvv = "A valid CVV is required";
    }

    if (Object.keys(errors).length > 0) {
      setCheckoutDataErrors(errors);
      toast.error("Please fill all security details properly");
      return;
    }

    setCheckoutDataErrors({});
    setCheckoutStep(2);

    // Multi-stage high quality status loader simulation
    const stages = [
      "Establishing secure SHA-256 cryptographic session...",
      "Validating slot allocation in Florentine atelier...",
      "Reserving dedicated priority courier tracking...",
      "Generating unique cryptographic Proof-of-Origin certificate..."
    ];

    let currentStage = 0;
    setCheckoutLoadingText(stages[0]);

    const interval = setInterval(() => {
      currentStage += 1;
      if (currentStage < stages.length) {
        setCheckoutLoadingText(stages[currentStage]);
      } else {
        clearInterval(interval);
        setCheckoutStep(3);
        setCart([]); // Clear cart
        toast.success("Reservation confirmed! Welcome to the Vanguard.");
      }
    }, 1200);
  };

  // -------------------------------------------------------------
  // PRODUCTS FILTERING & SORTING
  // -------------------------------------------------------------
  const filteredProducts = CATALOG_PRODUCTS.filter(product => {
    const matchesCategory = selectedCategory === "All" || product.category === selectedCategory;
    const matchesSearch = product.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
                          product.description.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  const sortedProducts = [...filteredProducts].sort((a, b) => {
    if (sortBy === "price-low") return a.price - b.price;
    if (sortBy === "price-high") return b.price - a.price;
    if (sortBy === "rating") return b.rating - a.rating;
    return 0; // default order
  });

  return (
    <div className="min-h-screen text-foreground bg-background transition-colors duration-500 flex flex-col font-sans selection:bg-amber-500/30 selection:text-amber-200">
      
      {/* Dynamic Toaster Notifications Container */}
      <Toaster position="top-center" closeButton richColors theme={theme} />

      {/* -------------------------------------------------------------
          HEADER & NAVIGATION LANDMARK
         ------------------------------------------------------------- */}
      <header className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 backdrop-blur-xl bg-black/60 border-b border-white/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 h-20 flex items-center justify-between">
          
          {/* Brand Logo & Name */}
          <div className="flex items-center gap-2">
            <div className="h-9 w-9 bg-gradient-to-tr from-amber-600 to-yellow-400 rounded-sm flex items-center justify-center shadow-lg shadow-amber-500/10">
              <Sparkles className="h-5 w-5 text-black" />
            </div>
            <div className="flex flex-col">
              <span data-testid="navbar-logo" className="text-xl font-serif font-light tracking-widest text-white uppercase">
                Maison de l'Élégance
              </span>
              <span className="text-[9px] uppercase tracking-[0.3em] font-mono text-amber-500/80 -mt-1">
                Mango AI Bags Studio
              </span>
            </div>
          </div>

          {/* Nav Links */}
          <nav className="hidden lg:flex items-center gap-10 font-mono text-xs uppercase tracking-widest">
            <a href="#collection" data-testid="navbar-link-collection" className="text-neutral-400 hover:text-amber-400 transition-colors duration-300">
              Collection
            </a>
            <a href="#atelier" data-testid="navbar-link-atelier" className="text-neutral-400 hover:text-amber-400 transition-colors duration-300">
              Atelier
            </a>
            <a href="#customizer" data-testid="navbar-link-customizer" className="text-neutral-400 hover:text-amber-400 transition-colors duration-300">
              Customizer
            </a>
            <a href="#quiz" data-testid="navbar-link-testimonials" className="text-neutral-400 hover:text-amber-400 transition-colors duration-300">
              Archetype Finder
            </a>
            <a href="#testimonials" className="text-neutral-400 hover:text-amber-400 transition-colors duration-300">
              Curations
            </a>
          </nav>

          {/* Utility Triggers */}
          <div className="flex items-center gap-4">
            
            {/* Theme Toggle Button */}
            <button 
              onClick={toggleTheme}
              data-testid="theme-toggle-button"
              className="p-2.5 rounded-full border border-white/10 text-neutral-300 hover:text-amber-400 hover:border-amber-400/40 bg-neutral-900/40 transition-all duration-300"
              aria-label="Toggle visual theme"
            >
              {theme === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
            </button>

            {/* Cart Drawer Trigger */}
            <button 
              onClick={() => setIsCartOpen(true)}
              data-testid="cart-drawer-trigger"
              className="relative p-2.5 rounded-full border border-white/10 text-neutral-300 hover:text-amber-400 hover:border-amber-400/40 bg-neutral-900/40 transition-all duration-300 flex items-center justify-center"
              aria-label="Open luxury shopping cart"
            >
              <ShoppingBag className="h-4 w-4" />
              {cart.length > 0 && (
                <span className="absolute -top-1 -right-1 h-4 w-4 bg-amber-500 text-black font-mono text-[9px] font-bold rounded-full flex items-center justify-center">
                  {cart.reduce((sum, item) => sum + item.quantity, 0)}
                </span>
              )}
            </button>
            
            <a href="#customizer" className="hidden sm:inline-flex px-5 py-2.5 bg-amber-500 hover:bg-amber-400 text-black text-xs font-mono font-medium uppercase tracking-widest rounded-sm transition-all duration-300 shadow-md shadow-amber-500/10">
              Bespoke Order
            </a>

          </div>
        </div>
      </header>

      {/* -------------------------------------------------------------
          MAIN LANDMARK - CINEMATIC CONTENT
         ------------------------------------------------------------- */}
      <main className="flex-grow pt-20">
        
        {/* HERO SECTION */}
        <section className="relative min-h-[90vh] flex items-center py-16 overflow-hidden bg-neutral-950">
          
          {/* Subtle Ambient Glow overlays */}
          <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-amber-600/10 rounded-full blur-[120px] pointer-events-none" />
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-yellow-500/10 rounded-full blur-[120px] pointer-events-none" />
          
          <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 w-full relative z-10">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
              
              {/* Left Column: Architectural copy */}
              <div className="lg:col-span-6 space-y-8 text-left">
                <div className="inline-flex items-center gap-2 px-3 py-1.5 border border-amber-500/20 bg-amber-500/5 text-amber-300 font-mono text-[10px] uppercase tracking-widest rounded-sm">
                  <Sparkles className="h-3.5 w-3.5" /> Hand-Glazed Florentine Calfskin
                </div>
                
                <h1 className="text-4xl sm:text-5xl lg:text-6xl font-serif font-light tracking-tight leading-[1.1] text-white">
                  Sculptural Luxury <br />
                  <span className="font-light italic text-amber-300">Form & Symmetry</span>
                </h1>
                
                <p className="text-sm sm:text-base font-light leading-relaxed text-neutral-400 max-w-xl">
                  Maison de l'Élégance presents an exquisite collection of luxury handbags. Each piece is dynamically conceived by algorithmic geometry and meticulously hand-finished by multi-generational master craftsmen in Italy.
                </p>

                <div className="flex flex-col sm:flex-row gap-4 pt-4">
                  <a 
                    href="#collection"
                    data-testid="hero-explore-btn"
                    className="px-8 py-4 bg-amber-500 hover:bg-amber-400 text-black font-mono text-xs uppercase tracking-widest rounded-sm transition-all duration-300 text-center shadow-lg shadow-amber-500/10 hover:shadow-amber-500/20 hover:-translate-y-0.5"
                  >
                    Explore Atelier
                  </a>
                  <a 
                    href="#customizer"
                    data-testid="hero-customizer-btn"
                    className="px-8 py-4 bg-transparent hover:bg-white/5 text-white border border-white/10 hover:border-amber-400/40 font-mono text-xs uppercase tracking-widest rounded-sm transition-all duration-300 text-center"
                  >
                    Bespoke Monogram
                  </a>
                </div>

                {/* Micro Stats */}
                <div className="grid grid-cols-3 gap-8 pt-8 border-t border-white/5 font-mono text-left">
                  <div>
                    <div className="text-2xl font-light text-white font-serif">100%</div>
                    <div className="text-[10px] text-neutral-500 uppercase tracking-wider mt-1">Full Grain Leather</div>
                  </div>
                  <div>
                    <div className="text-2xl font-light text-white font-serif">48 hrs</div>
                    <div className="text-[10px] text-neutral-500 uppercase tracking-wider mt-1">Stitching Per Bag</div>
                  </div>
                  <div>
                    <div className="text-2xl font-light text-white font-serif">Lifetime</div>
                    <div className="text-[10px] text-neutral-500 uppercase tracking-wider mt-1">Atelier Warranty</div>
                  </div>
                </div>

              </div>

              {/* Right Column: Editorial Hero Banner */}
              <div className="lg:col-span-6">
                <div className="relative group mx-auto max-w-md lg:max-w-none">
                  
                  {/* Decorative Frame */}
                  <div className="absolute -inset-2 rounded-sm border border-amber-500/15 scale-95 group-hover:scale-100 transition-all duration-700 pointer-events-none" />
                  
                  <div className="relative aspect-[4/5] overflow-hidden rounded-sm bg-neutral-900 border border-white/10 shadow-2xl">
                    <img 
                      src="https://images.unsplash.com/photo-1590739225287-bd31519780c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBoYW5kYmFnJTIwZWRpdG9yaWFsJTIwbW9kZWx8ZW58MHx8fHwxNzkxNzgyNjc5fDA&ixlib=rb-4.1.0&q=85" 
                      alt="Black leather luxury handbag on white textile backdrop"
                      className="w-full h-full object-cover object-center scale-100 group-hover:scale-105 transition-transform duration-1000"
                    />
                    
                    {/* Floating Info tag */}
                    <div className="absolute bottom-6 left-6 right-6 backdrop-blur-md bg-black/60 border border-white/10 p-5 rounded-sm flex items-center justify-between">
                      <div>
                        <span className="text-[9px] uppercase tracking-widest font-mono text-amber-400">Featured Masterpiece</span>
                        <h4 className="text-md font-serif font-light text-white mt-0.5">L'Élégance Noir Tote</h4>
                      </div>
                      <div className="font-mono text-xs text-neutral-300 font-bold">
                        $2,850
                      </div>
                    </div>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </section>

        {/* -------------------------------------------------------------
            THE ATELIER STORY & INTERACTIVE MATERIALS (ATELIER SECTION)
           ------------------------------------------------------------- */}
        <section id="atelier" className="py-24 border-t border-white/5 bg-neutral-900/30">
          <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
            
            {/* Overline & Heading */}
            <div className="text-center space-y-3 mb-16">
              <span className="text-xs uppercase tracking-[0.25em] font-mono font-medium text-amber-500">
                The Florentine Atelier
              </span>
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-serif font-normal tracking-tight text-white">
                Stitch by Stitch, Legacy Preserved
              </h2>
              <div className="h-[1px] w-12 bg-amber-500/50 mx-auto mt-4" />
            </div>

            {/* Atelier Craftsmanship Bento Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              
              {/* Artisan Block */}
              <div className="group space-y-4">
                <div className="aspect-[4/3] overflow-hidden rounded-sm bg-neutral-900 border border-white/5">
                  <img 
                    src="https://images.unsplash.com/photo-1611523794717-4d1f87dabf3b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHw0fHxoYW5kYmFnJTIwY3JhZnRzbWFuc2hpcCUyMGF0ZWxpZXJ8ZW58MHx8fHwxNzkxNzgyNjc4fDA&ixlib=rb-4.1.0&q=85" 
                    alt="Master artisan hand-stitching in Florence atelier" 
                    className="w-full h-full object-cover scale-100 group-hover:scale-105 transition-transform duration-700"
                  />
                </div>
                <div className="text-left space-y-1">
                  <div className="font-mono text-[9px] uppercase tracking-widest text-amber-400/80">Technique I</div>
                  <h3 className="text-lg font-serif font-medium text-white">Saddle Stitching</h3>
                  <p className="text-xs text-neutral-400 font-light">
                    Every seam is reinforced using double-needle hand-stitched linen threads, a process that ensures lifetime durability that machines cannot replicate.
                  </p>
                </div>
              </div>

              {/* Tooling Block */}
              <div className="group space-y-4">
                <div className="aspect-[4/3] overflow-hidden rounded-sm bg-neutral-900 border border-white/5">
                  <img 
                    src="https://images.unsplash.com/photo-1672302255324-28009cc288b2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxoYW5kYmFnJTIwY3JhZnRzbWFuc2hpcCUyMGF0ZWxpZXJ8ZW58MHx8fHwxNzkxNzgyNjc4fDA&ixlib=rb-4.1.0&q=85" 
                    alt="Precision leather tooling and edge glazing" 
                    className="w-full h-full object-cover scale-100 group-hover:scale-105 transition-transform duration-700"
                  />
                </div>
                <div className="text-left space-y-1">
                  <div className="font-mono text-[9px] uppercase tracking-widest text-amber-400/80">Technique II</div>
                  <h3 className="text-lg font-serif font-medium text-white">Edge Glazing</h3>
                  <p className="text-xs text-neutral-400 font-light">
                    Each raw leather edge is bevelled, sanded, and painted with six successive coats of bespoke botanical glaze to seal out moisture and maintain structural crispness.
                  </p>
                </div>
              </div>

              {/* Presentation Block */}
              <div className="group space-y-4">
                <div className="aspect-[4/3] overflow-hidden rounded-sm bg-neutral-900 border border-white/5">
                  <img 
                    src="https://images.unsplash.com/photo-1682745230951-8a5aa9a474a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxoYW5kYmFnJTIwY3JhZnRzbWFuc2hpcCUyMGF0ZWxpZXJ8ZW58MHx8fHwxNzkxNzgyNjc4fDA&ixlib=rb-4.1.0&q=85" 
                    alt="Finished ivory luxury handbag displayed on marble pedestal" 
                    className="w-full h-full object-cover scale-100 group-hover:scale-105 transition-transform duration-700"
                  />
                </div>
                <div className="text-left space-y-1">
                  <div className="font-mono text-[9px] uppercase tracking-widest text-amber-400/80">Technique III</div>
                  <h3 className="text-lg font-serif font-medium text-white">Atelier Assembly</h3>
                  <p className="text-xs text-neutral-400 font-light">
                    Finally, solid brass hardware is individually pinned. A numbered serial certificate is hand-embossed inside to secure the lineage of your investment.
                  </p>
                </div>
              </div>

            </div>
          </div>
        </section>

        {/* -------------------------------------------------------------
            FILTERABLE & SORTABLE PRODUCT SHOWCASE SECTION
           ------------------------------------------------------------- */}
        <section id="collection" className="py-24 border-t border-white/5 bg-neutral-950">
          <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
            
            {/* Header copy */}
            <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
              <div className="text-left space-y-3">
                <span className="text-xs uppercase tracking-[0.25em] font-mono font-medium text-amber-500">
                  Curated Catalog
                </span>
                <h2 className="text-2xl sm:text-3xl lg:text-4xl font-serif font-normal tracking-tight text-white">
                  The Ready-To-Wear Icons
                </h2>
                <p className="text-xs text-neutral-400 font-mono">
                  Showing {sortedProducts.length} premium pieces
                </p>
              </div>

              {/* Sorting and Search Panel */}
              <div className="flex flex-col sm:flex-row gap-4 items-center w-full md:w-auto">
                {/* Search Input */}
                <div className="relative w-full sm:w-64">
                  <Search className="absolute left-3.5 top-1/2 -translate-y-1/2 h-4 w-4 text-neutral-500" />
                  <input 
                    type="text" 
                    placeholder="Search curated line..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    data-testid="catalog-search-input"
                    className="w-full pl-10 pr-4 py-2.5 bg-neutral-900 border border-white/10 rounded-sm text-xs font-mono text-white focus:outline-none focus:border-amber-500/60 placeholder:text-neutral-600 transition-colors"
                  />
                </div>

                {/* Sort dropdown */}
                <div className="relative w-full sm:w-48">
                  <select 
                    value={sortBy} 
                    onChange={(e) => setSortBy(e.target.value)}
                    data-testid="catalog-sort-select"
                    className="w-full px-4 py-2.5 bg-neutral-900 border border-white/10 rounded-sm text-xs font-mono text-white focus:outline-none focus:border-amber-500/60 appearance-none cursor-pointer"
                  >
                    <option value="default">Sort by: Default</option>
                    <option value="price-low">Price: Low to High</option>
                    <option value="price-high">Price: High to Low</option>
                    <option value="rating">Rating: Highest First</option>
                  </select>
                </div>
              </div>
            </div>

            {/* Category Tab Filters */}
            <div className="flex flex-wrap gap-2 mb-10 border-b border-white/5 pb-6">
              {CATEGORIES.map((category) => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  data-testid={`catalog-category-tab-${category.toLowerCase().replace(/\s+/g, "-")}`}
                  className={`px-5 py-2.5 text-xs font-mono tracking-widest uppercase rounded-sm border transition-all duration-300 ${
                    selectedCategory === category 
                      ? "bg-amber-500 text-black border-amber-500" 
                      : "bg-neutral-900/50 text-neutral-400 border-white/5 hover:border-amber-500/30 hover:text-white"
                  }`}
                >
                  {category}
                </button>
              ))}
            </div>

            {/* Products Catalog Grid */}
            {sortedProducts.length === 0 ? (
              <div className="text-center py-20 border border-dashed border-white/10 rounded-sm">
                <Info className="h-8 w-8 text-neutral-500 mx-auto mb-3" />
                <p className="font-mono text-xs text-neutral-400">No masterpieces match your specified aesthetic query.</p>
                <button 
                  onClick={() => { setSelectedCategory("All"); setSearchQuery(""); setSortBy("default"); }} 
                  className="mt-4 text-xs font-mono text-amber-400 hover:underline"
                >
                  Reset filters
                </button>
              </div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-10">
                {sortedProducts.map((bag) => (
                  <article 
                    key={bag.id}
                    data-testid={`product-card-${bag.id}`}
                    className="group relative bg-neutral-900/30 border border-white/5 overflow-hidden rounded-sm hover:border-amber-500/40 transition-all duration-500 hover:shadow-[0_12px_40px_rgba(212,175,55,0.06)] flex flex-col h-full"
                  >
                    {/* Badge */}
                    <div className="absolute top-4 left-4 z-20">
                      <span className="px-2.5 py-1 bg-black/60 backdrop-blur-md border border-white/10 text-amber-300 font-mono text-[9px] uppercase tracking-widest rounded-sm">
                        {bag.category}
                      </span>
                    </div>

                    {/* Image frame */}
                    <div className="relative aspect-[4/5] bg-neutral-950 overflow-hidden">
                      <img 
                        src={bag.url} 
                        alt={bag.title}
                        className="w-full h-full object-cover object-center scale-100 group-hover:scale-105 transition-transform duration-700"
                      />
                      
                      {/* Dark gradient overlay */}
                      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                      
                      {/* Interactive hover actions overlay */}
                      <div className="absolute inset-0 flex items-center justify-center gap-3 opacity-0 group-hover:opacity-100 transition-all duration-300 scale-95 group-hover:scale-100">
                        
                        <button 
                          onClick={() => setQuickViewBag(bag)}
                          data-testid={`product-card-quick-view-${bag.id}`}
                          className="p-3.5 bg-black/80 hover:bg-amber-500 text-white hover:text-black rounded-full border border-white/15 hover:border-amber-500 transition-all duration-300 flex items-center justify-center shadow-lg"
                          title="Quick Inspect"
                        >
                          <Maximize2 className="h-4.5 w-4.5" />
                        </button>
                        
                        <button 
                          onClick={() => addToCart(bag)}
                          data-testid={`product-card-add-to-cart-${bag.id}`}
                          className="px-5 py-3.5 bg-amber-500 hover:bg-amber-400 text-black text-xs font-mono uppercase tracking-widest font-semibold rounded-sm transition-all duration-300 shadow-lg"
                        >
                          Add to Box
                        </button>

                      </div>
                    </div>

                    {/* Meta description box */}
                    <div className="p-6 flex flex-col flex-grow text-left space-y-2">
                      <div className="flex items-center justify-between">
                        <h3 className="text-xl font-serif font-light text-white group-hover:text-amber-300 transition-colors">
                          {bag.title}
                        </h3>
                        <div className="flex items-center gap-1 text-amber-400 font-mono text-[10px]">
                          <Star className="h-3 w-3 fill-amber-400 text-amber-400" />
                          <span>{bag.rating.toFixed(1)}</span>
                        </div>
                      </div>

                      <p className="text-xs text-neutral-400 font-light flex-grow leading-relaxed">
                        {bag.description.slice(0, 110)}...
                      </p>

                      <div className="flex items-center justify-between pt-4 border-t border-white/5 mt-auto">
                        <span className="font-mono text-sm text-neutral-300 font-medium">
                          ${bag.price.toLocaleString()}
                        </span>
                        
                        {/* Interactive direct link */}
                        <button 
                          onClick={() => setQuickViewBag(bag)}
                          className="text-[10px] uppercase font-mono tracking-wider text-amber-400/80 hover:text-amber-300 transition-colors flex items-center gap-1"
                        >
                          Atelier specs <ChevronRight className="h-3 w-3" />
                        </button>
                      </div>
                    </div>
                  </article>
                ))}
              </div>
            )}

          </div>
        </section>

        {/* -------------------------------------------------------------
            INTERACTIVE SHADCN-STYLE BAG FINDER QUIZ SECTION
           ------------------------------------------------------------- */}
        <section id="quiz" className="py-24 border-t border-white/5 bg-neutral-900/20">
          <div className="max-w-4xl mx-auto px-4 sm:px-8">
            <div className="bg-neutral-950 border border-white/10 rounded-sm p-8 sm:p-12 text-center space-y-8 relative overflow-hidden shadow-2xl">
              
              <div className="absolute top-0 right-0 w-32 h-32 bg-amber-500/5 rounded-full blur-3xl pointer-events-none" />
              
              <div className="space-y-3">
                <span className="text-xs uppercase tracking-[0.25em] font-mono font-medium text-amber-500">
                  Aesthetic Configurator
                </span>
                <h2 className="text-2xl sm:text-3xl font-serif font-normal tracking-tight text-white">
                  Discover Your Bag Archetype
                </h2>
                <p className="text-xs sm:text-sm text-neutral-400 max-w-lg mx-auto font-light">
                  Answer a single preference indicator and let our algorithmic Florentine selector match you to your ideal hand-stitched accessory.
                </p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-left">
                {[
                  {
                    id: "Daily Executive",
                    title: "The Visionary Executive",
                    description: "High boardrooms, legal dockets, architecture blueprints."
                  },
                  {
                    id: "Evening Gala",
                    title: "The Evening Avant-Garde",
                    description: "Soirées, Michelin-starred galas, gallery openings."
                  },
                  {
                    id: "Weekend Wanderer",
                    title: "The Leisure Connoisseur",
                    description: "Tuscan weekend getaways, coastal yacht strolls."
                  }
                ].map((item) => (
                  <button
                    key={item.id}
                    onClick={() => handleQuizSelection(item.id)}
                    data-testid={`quiz-archetype-select-${item.id.toLowerCase().replace(/\s+/g, "-")}`}
                    className={`p-6 border rounded-sm text-left transition-all duration-300 flex flex-col space-y-2 ${
                      quizArchetype === item.id 
                        ? "bg-amber-500/10 border-amber-500 text-white shadow-[0_4px_20px_rgba(212,175,55,0.08)]" 
                        : "bg-neutral-900/50 border-white/5 text-neutral-400 hover:border-white/10"
                    }`}
                  >
                    <span className="font-mono text-[9px] uppercase tracking-widest text-amber-400">Archetype</span>
                    <h4 className="font-serif text-md text-white font-medium">{item.title}</h4>
                    <p className="text-xs text-neutral-500 leading-relaxed font-light">{item.description}</p>
                  </button>
                ))}
              </div>

              {suggestedBag && (
                <div className="pt-6 border-t border-white/5 animate-fade-in text-left">
                  <div className="bg-neutral-900/60 border border-white/5 p-6 rounded-sm flex flex-col sm:flex-row items-center gap-6">
                    <img 
                      src={suggestedBag.url} 
                      alt={suggestedBag.title} 
                      className="h-28 w-24 object-cover rounded-sm border border-white/10"
                    />
                    <div className="flex-grow space-y-1 text-center sm:text-left">
                      <span className="text-[9px] uppercase tracking-widest font-mono text-amber-400">Your Tailored Match</span>
                      <h4 className="font-serif text-lg text-white">{suggestedBag.title}</h4>
                      <p className="text-xs text-neutral-400 font-light max-w-md">{suggestedBag.description.slice(0, 130)}...</p>
                      <div className="font-mono text-xs text-neutral-300 pt-2">${suggestedBag.price.toLocaleString()}</div>
                    </div>
                    <button
                      onClick={() => setQuickViewBag(suggestedBag)}
                      data-testid="quiz-view-suggestion-btn"
                      className="w-full sm:w-auto px-5 py-3 bg-amber-500 hover:bg-amber-400 text-black font-mono text-xs uppercase tracking-widest font-medium rounded-sm transition-all"
                    >
                      Inspect Match
                    </button>
                  </div>
                </div>
              )}

            </div>
          </div>
        </section>

        {/* -------------------------------------------------------------
            AI BESPOKE COUTURIER CUSTOMIZER (CUSTOMIZER SECTION)
           ------------------------------------------------------------- */}
        <section id="customizer" data-testid="bespoke-customizer-section" className="py-24 border-t border-white/5 bg-neutral-950 relative">
          
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-amber-500/5 rounded-full blur-[160px] pointer-events-none" />

          <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 relative z-10">
            
            {/* Header */}
            <div className="text-center space-y-3 mb-16">
              <span className="text-xs uppercase tracking-[0.25em] font-mono font-medium text-amber-500">
                Digital Atelier
              </span>
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-serif font-normal tracking-tight text-white">
                Bespoke Leather Customizer
              </h2>
              <p className="text-xs sm:text-sm text-neutral-400 max-w-xl mx-auto font-light">
                Tailor a custom architectural hand-stitched accessory. Select your exquisite grain, metal finish, custom initials, and preview estimated crafting slot.
              </p>
              <div className="h-[1px] w-12 bg-amber-500/50 mx-auto mt-4" />
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
              
              {/* Left Column: Interactive Settings Panel */}
              <div className="lg:col-span-7 bg-neutral-900/40 border border-white/5 p-8 sm:p-10 rounded-sm space-y-8 text-left">
                
                {/* 1. Leather Material selector */}
                <div className="space-y-4">
                  <label className="font-mono text-xs uppercase tracking-widest text-amber-400 flex items-center justify-between">
                    <span>1. Select Leather Grain</span>
                    <span className="text-neutral-500">Adds premium weight</span>
                  </label>
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                    {[
                      { id: "Pebbled Calfskin", desc: "Italian full grain", extra: "Base Price" },
                      { id: "Smooth Box Calf", desc: "Aniline glossy finish", extra: "+$150" },
                      { id: "Crocodile Embossed", desc: "Structural exotic look", extra: "+$450" }
                    ].map((item) => (
                      <button
                        key={item.id}
                        type="button"
                        onClick={() => setCustomLeather(item.id)}
                        data-testid={`customizer-leather-select-${item.id.toLowerCase().replace(/\s+/g, "-")}`}
                        className={`p-4 border text-left rounded-sm transition-all flex flex-col space-y-1 ${
                          customLeather === item.id 
                            ? "bg-amber-500/5 border-amber-500 text-white" 
                            : "bg-black/40 border-white/5 text-neutral-400 hover:border-white/10"
                        }`}
                      >
                        <span className="text-xs font-mono font-medium text-white">{item.id}</span>
                        <span className="text-[10px] text-neutral-500 font-light">{item.desc}</span>
                        <span className="text-[9px] font-mono text-amber-400/80 pt-1 font-semibold">{item.extra}</span>
                      </button>
                    ))}
                  </div>
                </div>

                {/* 2. Metal Hardware Selector */}
                <div className="space-y-4">
                  <label className="font-mono text-xs uppercase tracking-widest text-amber-400 flex items-center justify-between">
                    <span>2. Hardware Finish</span>
                    <span className="text-neutral-500">Premium solid locks</span>
                  </label>
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                    {[
                      { id: "Polished Brass", extra: "Included" },
                      { id: "Brushed Palladium", extra: "Included" },
                      { id: "Rose Gold", extra: "+$100" }
                    ].map((item) => (
                      <button
                        key={item.id}
                        type="button"
                        onClick={() => setCustomHardware(item.id)}
                        data-testid={`customizer-hardware-select-${item.id.toLowerCase().replace(/\s+/g, "-")}`}
                        className={`p-4 border text-left rounded-sm transition-all flex flex-col space-y-1 ${
                          customHardware === item.id 
                            ? "bg-amber-500/5 border-amber-500 text-white" 
                            : "bg-black/40 border-white/5 text-neutral-400 hover:border-white/10"
                        }`}
                      >
                        <span className="text-xs font-mono font-medium text-white">{item.id}</span>
                        <span className="text-[10px] text-neutral-500 font-light">Italian solid alloy</span>
                        <span className="text-[9px] font-mono text-amber-400/80 pt-1 font-semibold">{item.extra}</span>
                      </button>
                    ))}
                  </div>
                </div>

                {/* 3. Interior Lining Selector */}
                <div className="space-y-4">
                  <label className="font-mono text-xs uppercase tracking-widest text-amber-400">
                    3. Silk & Suede Lining
                  </label>
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                    {[
                      { id: "Ruby Velvet", desc: "Plush density velvet" },
                      { id: "Emerald Satin", desc: "Fine weave sateen" },
                      { id: "Midnight Silk", desc: "Heavy weight silk weave" }
                    ].map((item) => (
                      <button
                        key={item.id}
                        type="button"
                        onClick={() => setCustomLining(item.id)}
                        data-testid={`customizer-lining-select-${item.id.toLowerCase().replace(/\s+/g, "-")}`}
                        className={`p-4 border text-left rounded-sm transition-all flex flex-col space-y-1 ${
                          customLining === item.id 
                            ? "bg-amber-500/5 border-amber-500 text-white" 
                            : "bg-black/40 border-white/5 text-neutral-400 hover:border-white/10"
                        }`}
                      >
                        <span className="text-xs font-mono font-medium text-white">{item.id}</span>
                        <span className="text-[10px] text-neutral-500 font-light">{item.desc}</span>
                      </button>
                    ))}
                  </div>
                </div>

                {/* 4. Custom Monogram */}
                <div className="space-y-4">
                  <label className="font-mono text-xs uppercase tracking-widest text-amber-400 flex items-center justify-between">
                    <span>4. Heat-Embossed Monogram (+$50)</span>
                    <span className="text-[10px] text-neutral-500">Max 3 initials</span>
                  </label>
                  <input
                    type="text"
                    maxLength={3}
                    placeholder="E.g., MDE"
                    value={customMonogram}
                    onChange={(e) => setCustomMonogram(e.target.value.toUpperCase().slice(0, 3))}
                    data-testid="customizer-monogram-input"
                    className="w-full px-4 py-3 bg-black/40 border border-white/10 rounded-sm text-sm font-mono text-white focus:outline-none focus:border-amber-500/60 placeholder:text-neutral-700 uppercase"
                  />
                </div>

              </div>

              {/* Right Column: Visual Live Estimation Box */}
              <div className="lg:col-span-5 space-y-6">
                
                {/* Visual rendering simulation card */}
                <div className="bg-neutral-900 border border-white/10 rounded-sm overflow-hidden text-left shadow-2xl">
                  
                  <div className="relative aspect-square bg-neutral-950 overflow-hidden flex items-center justify-center border-b border-white/5">
                    <img 
                      src="https://images.unsplash.com/photo-1682745230951-8a5aa9a474a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxoYW5kYmFnJTIwY3JhZnRzbWFuc2hpcCUyMGF0ZWxpZXJ8ZW58MHx8fHwxNzkxNzgyNjc4fDA&ixlib=rb-4.1.0&q=85" 
                      alt="Luxury bespoke product preview"
                      className="w-full h-full object-cover opacity-90"
                    />
                    
                    {/* Floating virtual rendering labels */}
                    <div className="absolute top-4 right-4 bg-black/60 backdrop-blur-md border border-white/10 px-3 py-1.5 rounded-sm flex items-center gap-1.5">
                      <div className="h-2 w-2 rounded-full bg-emerald-500 animate-pulse" />
                      <span className="font-mono text-[9px] uppercase tracking-widest text-neutral-300">Live Virtual Spec</span>
                    </div>

                    {/* Monogram Overlay Simulation */}
                    {customMonogram && (
                      <div className="absolute bottom-1/3 left-1/2 -translate-x-1/2 bg-black/40 backdrop-blur-sm border border-amber-500/30 px-4 py-2 text-center rounded-sm">
                        <span className="font-mono text-[10px] uppercase tracking-widest text-amber-500 block">Monogram</span>
                        <span className="font-serif text-lg tracking-[0.2em] font-light text-white italic">{customMonogram}</span>
                      </div>
                    )}
                  </div>

                  {/* Pricing Details */}
                  <div className="p-8 space-y-6">
                    <div className="space-y-2">
                      <h3 className="text-xl font-serif font-light text-white">Bespoke Satchel Recipe</h3>
                      <p className="text-xs text-neutral-400 font-light">Custom formulated for your unique aesthetic. Order requires 14 business days crafting time.</p>
                    </div>

                    <div className="font-mono text-xs space-y-2.5 border-t border-b border-white/5 py-4 text-neutral-400">
                      <div className="flex justify-between">
                        <span>Base Satchel</span>
                        <span>$2,500</span>
                      </div>
                      <div className="flex justify-between">
                        <span>Leather: {customLeather}</span>
                        <span>{customLeather === "Crocodile Embossed" ? "+$450" : customLeather === "Smooth Box Calf" ? "+$150" : "$0"}</span>
                      </div>
                      <div className="flex justify-between">
                        <span>Hardware: {customHardware}</span>
                        <span>{customHardware === "Rose Gold" ? "+$100" : "$0"}</span>
                      </div>
                      <div className="flex justify-between">
                        <span>Lining: {customLining}</span>
                        <span>Included</span>
                      </div>
                      {customMonogram && (
                        <div className="flex justify-between text-amber-400">
                          <span>Hot Monogram ({customMonogram})</span>
                          <span>+$50</span>
                        </div>
                      )}
                    </div>

                    <div className="flex items-center justify-between">
                      <div>
                        <span className="text-[10px] text-neutral-500 uppercase tracking-wider font-mono">Bespoke Price</span>
                        <div className="font-mono text-xl text-white font-bold">${getBespokePrice().toLocaleString()}</div>
                      </div>
                      <button
                        onClick={handleAddBespokeToCart}
                        data-testid="customizer-add-to-cart-btn"
                        className="px-6 py-4.5 bg-amber-500 hover:bg-amber-400 text-black text-xs font-mono uppercase tracking-widest font-semibold rounded-sm transition-all duration-300 shadow-lg shadow-amber-500/10"
                      >
                        Add to Atelier Box
                      </button>
                    </div>
                  </div>

                </div>

              </div>

            </div>
          </div>
        </section>

        {/* -------------------------------------------------------------
            CELEBRITY LOOKBOOK & CLIENT TESTIMONIALS SECTION
           ------------------------------------------------------------- */}
        <section id="testimonials" className="py-24 border-t border-white/5 bg-neutral-900/30 text-left">
          <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
            
            <div className="text-center space-y-3 mb-16">
              <span className="text-xs uppercase tracking-[0.25em] font-mono font-medium text-amber-500">
                Editorial Appreciations
              </span>
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-serif font-normal tracking-tight text-white">
                Voices of the Connoisseurs
              </h2>
              <div className="h-[1px] w-12 bg-amber-500/50 mx-auto mt-4" />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {[
                {
                  quote: "Maison de l'Élégance achieves a flawless harmony of structural geometry and artisanal craftsmanship. The stitch density and leather glazing rival the historic fashion houses of Paris, but with a sleek contemporary vision.",
                  author: "Sienna de Luca",
                  title: "Creative Director, Milan Vogue Review"
                },
                {
                  quote: "My bespoke monogrammed box calf clutch is an absolute masterpiece. Every single interaction with the polished brass hardware feels tactile, heavy, and satisfyingly mechanical. Truly architectural sculpture.",
                  author: "Dr. Alistair Vance",
                  title: "Collector & Architectural Historian"
                },
                {
                  quote: "The algorithmic matching matched me with the Aura Cognac Duffle. It has become my indispensable travel partner. The vegetable-tanned leather has aged into a rich, deep mahogany with a unique golden patina.",
                  author: "Gemma Moretti",
                  title: "Boutique Curator, Florence"
                }
              ].map((item, idx) => (
                <div 
                  key={idx}
                  className="bg-neutral-950 border border-white/5 p-8 rounded-sm space-y-6 flex flex-col justify-between"
                >
                  <div className="space-y-4">
                    <div className="flex gap-1 text-amber-500">
                      {[...Array(5)].map((_, i) => (
                        <Star key={i} className="h-3.5 w-3.5 fill-amber-500" />
                      ))}
                    </div>
                    <blockquote className="text-xs sm:text-sm font-serif font-light text-neutral-300 italic leading-relaxed">
                      "{item.quote}"
                    </blockquote>
                  </div>
                  <div className="pt-4 border-t border-white/5">
                    <cite className="not-italic block">
                      <span className="font-mono text-xs font-semibold text-white block">{item.author}</span>
                      <span className="font-mono text-[9px] uppercase tracking-widest text-neutral-500">{item.title}</span>
                    </cite>
                  </div>
                </div>
              ))}
            </div>

          </div>
        </section>

        {/* -------------------------------------------------------------
            NEWSLETTER / VIP CLUB SIGNUP SECTION
           ------------------------------------------------------------- */}
        <section className="py-24 border-t border-white/5 bg-neutral-950">
          <div className="max-w-4xl mx-auto px-4 sm:px-8 text-center space-y-8">
            
            <div className="space-y-3">
              <span className="text-xs uppercase tracking-[0.25em] font-mono font-medium text-amber-500">
                Exclusive Invitation
              </span>
              <h2 className="text-2xl sm:text-3xl font-serif font-normal tracking-tight text-white">
                Join the Vanguard Atelier Club
              </h2>
              <p className="text-xs sm:text-sm text-neutral-400 max-w-lg mx-auto font-light leading-relaxed">
                Subscribe to receive seasonal invitations to bespoke leather batch runs, private studio collection releases, and luxury lifestyle dispatches.
              </p>
            </div>

            {newsletterSuccess ? (
              <div className="p-8 border border-amber-500/20 bg-amber-500/5 rounded-sm max-w-md mx-auto animate-fade-in">
                <Check className="h-8 w-8 text-amber-400 mx-auto mb-3" />
                <h4 className="font-serif text-lg text-white font-medium">Welcome to the Inner Circle</h4>
                <p className="font-mono text-[10px] text-amber-300/80 mt-1">Your unique Atelier invitation key: <span className="font-bold underline text-white">VIP-ATELIER-2026</span></p>
                <p className="text-xs text-neutral-500 font-light mt-2">Private previews and early reservation access will be dispatched to your encrypted mailbox.</p>
              </div>
            ) : (
              <form 
                onSubmit={(e) => { e.preventDefault(); if (newsletterEmail) { setNewsletterSuccess(true); toast.success("Subscribed to the private Vanguard Club"); } }}
                className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
              >
                <div className="relative flex-grow">
                  <Mail className="absolute left-3.5 top-1/2 -translate-y-1/2 h-4 w-4 text-neutral-500" />
                  <input 
                    type="email" 
                    required
                    placeholder="Enter your email address..."
                    value={newsletterEmail}
                    onChange={(e) => setNewsletterEmail(e.target.value)}
                    data-testid="newsletter-email-input"
                    className="w-full pl-10 pr-4 py-3 bg-neutral-900 border border-white/10 rounded-sm text-xs font-mono text-white focus:outline-none focus:border-amber-500/60 placeholder:text-neutral-600"
                  />
                </div>
                <button
                  type="submit"
                  data-testid="newsletter-submit-btn"
                  className="px-6 py-3 bg-amber-500 hover:bg-amber-400 text-black font-mono text-xs uppercase tracking-widest font-semibold rounded-sm transition-all duration-300 shadow-md shadow-amber-500/10"
                >
                  Join Club
                </button>
              </form>
            )}

          </div>
        </section>

      </main>

      {/* -------------------------------------------------------------
          FOOTER LANDMARK
         ------------------------------------------------------------- */}
      <footer className="bg-neutral-950 border-t border-white/5 py-12 text-left">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 grid grid-cols-1 md:grid-cols-4 gap-8">
          
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <span className="text-md font-serif tracking-widest uppercase text-white">Maison de l'Élégance</span>
            </div>
            <p className="text-xs text-neutral-500 leading-relaxed font-light">
              Architectural luxury, designed by algorithm and brought to life in Florentine master craft-workshops. Represented exclusively online under TagMango's Mango Studio.
            </p>
          </div>

          <div className="space-y-3 font-mono text-xs">
            <h5 className="text-white uppercase tracking-widest font-bold">Categories</h5>
            <ul className="space-y-2 text-neutral-500">
              <li><a href="#collection" className="hover:text-amber-400 transition-colors">Architectural Totes</a></li>
              <li><a href="#collection" className="hover:text-amber-400 transition-colors">Crossbody & Clutches</a></li>
              <li><a href="#collection" className="hover:text-amber-400 transition-colors">Limited Edition AI Pieces</a></li>
              <li><a href="#customizer" className="hover:text-amber-400 transition-colors">Bespoke Customizer</a></li>
            </ul>
          </div>

          <div className="space-y-3 font-mono text-xs">
            <h5 className="text-white uppercase tracking-widest font-bold">The Studio</h5>
            <p className="text-neutral-500 text-xs font-light leading-relaxed">
              Creator ID: 697cb443abc32c065eaf87d5 <br />
              Secure Ingress Base URL: <br />
              <a href="https://api-prod-new.tagmango.com" className="text-amber-400 hover:underline">api-prod-new.tagmango.com</a> <br />
              Registered domain: <br />
              <a href="https://fisrpoll.moiraa.xyz" className="text-amber-400 hover:underline">fisrpoll.moiraa.xyz</a>
            </p>
          </div>

          <div className="space-y-3 font-mono text-xs">
            <h5 className="text-white uppercase tracking-widest font-bold">Warranty & Trust</h5>
            <ul className="space-y-2 text-neutral-500 text-xs font-light">
              <li className="flex items-center gap-1.5"><ShieldCheck className="h-3.5 w-3.5 text-amber-500" /> Lifetime Stitch Guarantee</li>
              <li className="flex items-center gap-1.5"><Activity className="h-3.5 w-3.5 text-amber-500" /> Proof-of-Origin Certificate</li>
              <li className="flex items-center gap-1.5"><Award className="h-3.5 w-3.5 text-amber-500" /> Secure Token Handshake</li>
            </ul>
          </div>

        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 pt-8 mt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4 font-mono text-[10px] text-neutral-600">
          <div>
            © 2026 Maison de l'Élégance. All rights reserved. Built with pride inside Mango Studio.
          </div>
          <div className="flex gap-4">
            <a href="#" className="hover:underline">Privacy Charter</a>
            <span className="text-neutral-800">|</span>
            <a href="#" className="hover:underline">Bespoke Terms</a>
            <span className="text-neutral-800">|</span>
            <span className="text-amber-500">Mango AI Builder</span>
          </div>
        </div>
      </footer>

      {/* -------------------------------------------------------------
          PRODUCT QUICK VIEW / INSPECT MODAL (PORTAL DIALOG MOCK)
         ------------------------------------------------------------- */}
      {quickViewBag && (
        <div 
          data-testid="quick-view-modal"
          className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/85 backdrop-blur-md animate-fade-in"
          role="dialog"
          aria-modal="true"
        >
          <div className="relative max-w-4xl w-full bg-neutral-900 border border-white/10 rounded-sm overflow-hidden shadow-2xl flex flex-col md:flex-row text-left max-h-[90vh] md:max-h-[80vh]">
            
            {/* Close trigger button */}
            <button 
              onClick={() => setQuickViewBag(null)}
              data-testid="quick-view-close"
              className="absolute top-4 right-4 z-10 p-2 rounded-full bg-black/50 hover:bg-amber-500 text-neutral-300 hover:text-black border border-white/10 transition-colors"
              aria-label="Close product view"
            >
              <X className="h-4.5 w-4.5" />
            </button>

            {/* Left Hand Column Image Container */}
            <div className="w-full md:w-1/2 relative bg-neutral-950 min-h-[300px] md:min-h-[450px]">
              <img 
                src={quickViewBag.url} 
                alt={quickViewBag.title} 
                className="w-full h-full object-cover object-center"
              />
              <div className="absolute bottom-4 left-4">
                <span className="px-2 py-1 bg-black/60 border border-white/10 text-amber-300 font-mono text-[9px] uppercase tracking-widest rounded-sm">
                  {quickViewBag.category}
                </span>
              </div>
            </div>

            {/* Right Hand Column Detail description Panel */}
            <div className="w-full md:w-1/2 p-6 sm:p-8 flex flex-col justify-between overflow-y-auto">
              <div className="space-y-6">
                <div>
                  <h3 className="text-2xl font-serif font-light text-white">{quickViewBag.title}</h3>
                  <div className="flex items-center gap-1.5 text-amber-400 font-mono text-xs mt-1">
                    <Star className="h-3.5 w-3.5 fill-amber-400" />
                    <span>{quickViewBag.rating.toFixed(1)} / 5.0 Rating</span>
                  </div>
                </div>

                <p className="text-xs text-neutral-400 font-light leading-relaxed">
                  {quickViewBag.description}
                </p>

                {/* Additional Spec labels */}
                <div className="grid grid-cols-2 gap-4 border-t border-b border-white/5 py-4 text-xs font-mono text-neutral-400">
                  <div>
                    <span className="text-neutral-500 block text-[9px] uppercase tracking-wider">Dimensions</span>
                    <span className="text-white font-medium">{quickViewBag.dimensions}</span>
                  </div>
                  <div>
                    <span className="text-neutral-500 block text-[9px] uppercase tracking-wider">Weight</span>
                    <span className="text-white font-medium">{quickViewBag.weight}</span>
                  </div>
                  <div className="col-span-2">
                    <span className="text-neutral-500 block text-[9px] uppercase tracking-wider">Atelier Materials</span>
                    <span className="text-white font-medium">{quickViewBag.materials}</span>
                  </div>
                </div>

                {/* Micro customizations */}
                <div className="space-y-4">
                  <div>
                    <span className="text-neutral-500 block text-[9px] uppercase tracking-widest font-mono mb-2">Micro stitch color</span>
                    <div className="flex gap-2">
                      {["Champagne Gold", "Ivory White", "Ebony Black"].map((color) => (
                        <button
                          key={color}
                          onClick={() => setQuickViewStitching(color)}
                          className={`px-3 py-1.5 border font-mono text-[9px] uppercase tracking-wider rounded-sm transition-all ${
                            quickViewStitching === color 
                              ? "bg-amber-500/10 border-amber-500 text-white" 
                              : "bg-neutral-950 border-white/5 text-neutral-500 hover:border-white/10"
                          }`}
                        >
                          {color}
                        </button>
                      ))}
                    </div>
                  </div>
                  
                  <div>
                    <span className="text-neutral-500 block text-[9px] uppercase tracking-widest font-mono mb-2">Strap choice</span>
                    <div className="flex gap-2">
                      {["Classic Leather Handle", "Adjustable Shoulder Strap"].map((strap) => (
                        <button
                          key={strap}
                          onClick={() => setQuickViewStrap(strap)}
                          className={`px-3 py-1.5 border font-mono text-[9px] uppercase tracking-wider rounded-sm transition-all ${
                            quickViewStrap === strap 
                              ? "bg-amber-500/10 border-amber-500 text-white" 
                              : "bg-neutral-950 border-white/5 text-neutral-500 hover:border-white/10"
                          }`}
                        >
                          {strap}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>

              </div>

              <div className="flex items-center justify-between pt-6 border-t border-white/5 mt-6">
                <div>
                  <span className="text-[9px] text-neutral-500 uppercase tracking-widest font-mono">Investment Price</span>
                  <div className="font-mono text-lg text-white font-bold">${quickViewBag.price.toLocaleString()}</div>
                </div>
                <button
                  onClick={() => {
                    addToCart(quickViewBag, {
                      leather: "Default Masterpiece Calfskin",
                      hardware: "Default Brass Lock",
                      lining: "Plush Velvet Suede",
                      monogram: `${quickViewStitching.slice(0, 1)}${quickViewStrap.slice(0, 1)}`
                    });
                    setQuickViewBag(null);
                  }}
                  data-testid="quick-view-add-to-cart"
                  className="px-6 py-4 bg-amber-500 hover:bg-amber-400 text-black text-xs font-mono uppercase tracking-widest font-bold rounded-sm transition-all duration-300 shadow-lg shadow-amber-500/10"
                >
                  Add to Atelier Box
                </button>
              </div>

            </div>

          </div>
        </div>
      )}

      {/* -------------------------------------------------------------
          LUXURY SLIDE-OUT CART DRAWER PANEL
         ------------------------------------------------------------- */}
      {isCartOpen && (
        <div className="fixed inset-0 z-50 overflow-hidden bg-black/80 backdrop-blur-sm animate-fade-in">
          <div className="absolute inset-y-0 right-0 max-w-full flex pl-10">
            
            <div className="w-screen max-w-md bg-neutral-950 border-l border-white/10 text-neutral-100 flex flex-col shadow-2xl relative">
              
              {/* Top Banner details */}
              <div className="p-6 border-b border-white/5 flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <ShoppingBag className="h-5 w-5 text-amber-400" />
                  <h3 className="text-lg font-serif font-light text-white">Your Atelier Box</h3>
                </div>
                
                <button 
                  onClick={() => setIsCartOpen(false)}
                  data-testid="cart-drawer-close"
                  className="p-2 text-neutral-400 hover:text-white transition-colors"
                  aria-label="Close cart"
                >
                  <X className="h-5 w-5" />
                </button>
              </div>

              {/* Items Container */}
              <div className="flex-1 overflow-y-auto p-6 space-y-6">
                {cart.length === 0 ? (
                  <div className="text-center py-20 space-y-4">
                    <ShoppingBag className="h-10 w-10 text-neutral-600 mx-auto" />
                    <p className="font-mono text-xs text-neutral-500">Your luxury cart box is empty.</p>
                    <button 
                      onClick={() => setIsCartOpen(false)}
                      className="text-xs font-mono text-amber-400 hover:underline uppercase tracking-widest"
                    >
                      Browse line
                    </button>
                  </div>
                ) : (
                  cart.map((item) => {
                    // Pricing adjustment for customized item
                    let singlePrice = item.price;
                    if (item.customization) {
                      if (item.customization.leather === "Crocodile Embossed") singlePrice += 450;
                      if (item.customization.leather === "Smooth Box Calf") singlePrice += 150;
                      if (item.customization.hardware === "Rose Gold") singlePrice += 100;
                      if (item.customization.monogram) singlePrice += 50;
                    }

                    return (
                      <div 
                        key={item.cartKey}
                        className="flex gap-4 bg-neutral-900/40 border border-white/5 p-4 rounded-sm relative group text-left"
                      >
                        <img 
                          src={item.url} 
                          alt={item.title} 
                          className="h-20 w-16 object-cover rounded-sm border border-white/10"
                        />
                        <div className="flex-grow space-y-1">
                          <h4 className="font-serif text-sm text-white font-medium">{item.title}</h4>
                          <span className="text-[9px] uppercase tracking-widest font-mono text-neutral-500 block">
                            {item.category}
                          </span>
                          
                          {/* Monogram or custom detail line */}
                          {item.customization && (
                            <div className="text-[10px] font-mono text-amber-400/80 space-y-0.5 pt-1">
                              <div>Leather: {item.customization.leather}</div>
                              <div>Hardware: {item.customization.hardware}</div>
                              {item.customization.monogram && <div>Monogram: "{item.customization.monogram}"</div>}
                            </div>
                          )}

                          <div className="flex items-center justify-between pt-3">
                            {/* Quantity Controls */}
                            <div className="flex items-center gap-2 bg-black border border-white/10 rounded-sm">
                              <button 
                                onClick={() => updateQuantity(item.cartKey, -1)}
                                data-testid={`cart-item-quantity-dec-${item.id}`}
                                className="p-1 text-neutral-400 hover:text-white"
                                aria-label="Decrease quantity"
                              >
                                <Minus className="h-3 w-3" />
                              </button>
                              <span className="font-mono text-xs text-white px-1">{item.quantity}</span>
                              <button 
                                onClick={() => updateQuantity(item.cartKey, 1)}
                                data-testid={`cart-item-quantity-inc-${item.id}`}
                                className="p-1 text-neutral-400 hover:text-white"
                                aria-label="Increase quantity"
                              >
                                <Plus className="h-3 w-3" />
                              </button>
                            </div>

                            <span className="font-mono text-xs text-neutral-300 font-bold">
                              ${(singlePrice * item.quantity).toLocaleString()}
                            </span>
                          </div>
                        </div>

                        {/* Remove item button */}
                        <button 
                          onClick={() => removeFromCart(item.cartKey, item.title)}
                          data-testid={`cart-item-remove-${item.id}`}
                          className="absolute top-2 right-2 p-1 text-neutral-500 hover:text-red-400 opacity-0 group-hover:opacity-100 transition-opacity"
                          aria-label="Remove item"
                        >
                          <Trash2 className="h-4 w-4" />
                        </button>
                      </div>
                    );
                  })
                )}
              </div>

              {/* Promo and total pricing drawer container footer */}
              {cart.length > 0 && (
                <div className="p-6 border-t border-white/10 bg-neutral-900/60 text-left space-y-6">
                  
                  {/* Coupon form */}
                  <form onSubmit={handleApplyCoupon} className="flex gap-2">
                    <input 
                      type="text" 
                      placeholder="Atelier Voucher (E.g. MaisonVIP)"
                      value={promoCode}
                      onChange={(e) => setPromoCode(e.target.value)}
                      data-testid="cart-coupon-input"
                      className="flex-grow px-3 py-2 bg-neutral-950 border border-white/10 rounded-sm text-xs font-mono text-white focus:outline-none focus:border-amber-500/60 uppercase"
                    />
                    <button 
                      type="submit"
                      data-testid="cart-coupon-apply-btn"
                      className="px-4 py-2 bg-transparent hover:bg-white/5 border border-white/10 hover:border-amber-500 text-neutral-300 hover:text-white font-mono text-xs uppercase rounded-sm transition-all"
                    >
                      Apply
                    </button>
                  </form>

                  {/* Calculations */}
                  <div className="font-mono text-xs space-y-2 text-neutral-400">
                    <div className="flex justify-between">
                      <span>Subtotal</span>
                      <span className="text-white">${getSubtotal().toLocaleString()}</span>
                    </div>
                    {appliedDiscount > 0 && (
                      <div className="flex justify-between text-amber-400">
                        <span>VIP Discount ({appliedDiscount * 100}%)</span>
                        <span>-${(getSubtotal() * appliedDiscount).toLocaleString()}</span>
                      </div>
                    )}
                    <div className="flex justify-between border-t border-white/5 pt-3 text-sm font-semibold">
                      <span className="text-white font-serif font-light">Atelier Total</span>
                      <span className="text-amber-400 font-bold">${getDiscountedTotal().toLocaleString()}</span>
                    </div>
                  </div>

                  {/* Secure checkout trigger */}
                  <button 
                    onClick={() => { setIsCartOpen(false); setIsCheckoutOpen(true); setCheckoutStep(1); }}
                    data-testid="cart-checkout-btn"
                    className="w-full py-4 bg-amber-500 hover:bg-amber-400 text-black font-mono text-xs uppercase tracking-widest font-bold rounded-sm transition-all duration-300 shadow-lg shadow-amber-500/10 flex items-center justify-center gap-2"
                  >
                    <Lock className="h-3.5 w-3.5" /> Secure Atelier Checkout
                  </button>

                  <div className="text-[10px] text-neutral-500 font-mono text-center flex items-center justify-center gap-1.5">
                    <Lock className="h-3 w-3" /> Encrypted via TLS cryptographic tunnel
                  </div>
                </div>
              )}

            </div>

          </div>
        </div>
      )}

      {/* -------------------------------------------------------------
          SECURE SIMULATED ORDER CHECKOUT MODAL FLOW
         ------------------------------------------------------------- */}
      {isCheckoutOpen && (
        <div 
          data-testid="checkout-modal"
          className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/85 backdrop-blur-md animate-fade-in"
          role="dialog"
          aria-modal="true"
        >
          <div className="relative max-w-xl w-full bg-neutral-900 border border-white/10 rounded-sm overflow-hidden shadow-2xl p-6 sm:p-10 text-left">
            
            {/* Close button */}
            <button 
              onClick={() => setIsCheckoutOpen(false)}
              data-testid="checkout-close-btn"
              className="absolute top-4 right-4 p-2 rounded-full hover:bg-white/5 text-neutral-400 hover:text-white transition-colors"
              aria-label="Close checkout"
            >
              <X className="h-5 w-5" />
            </button>

            {/* STEP 1: Elegant Input Form */}
            {checkoutStep === 1 && (
              <form onSubmit={handleCheckoutSubmit} className="space-y-6">
                <div className="space-y-2">
                  <span className="text-[9px] uppercase tracking-widest font-mono text-amber-400 block">Atelier Security Gate</span>
                  <h3 className="text-2xl font-serif font-light text-white">Private Slot Reservation</h3>
                  <p className="text-xs text-neutral-400 font-light leading-relaxed">Secure your bespoke mastercraft slots. All details will remain strictly offline inside the Florentine archives.</p>
                </div>

                <div className="space-y-4">
                  {/* Name */}
                  <div className="space-y-1.5">
                    <label className="font-mono text-[10px] uppercase tracking-wider text-neutral-400">Recipient Full Name</label>
                    <input 
                      type="text" 
                      name="name"
                      required
                      value={checkoutData.name}
                      onChange={handleInputChange}
                      data-testid="checkout-name-input"
                      className="w-full px-4 py-2.5 bg-black/40 border border-white/10 rounded-sm text-xs font-mono text-white focus:outline-none focus:border-amber-500/60"
                    />
                    {checkoutErrors.name && <p className="text-[10px] text-red-400 font-mono">{checkoutErrors.name}</p>}
                  </div>

                  {/* Email */}
                  <div className="space-y-1.5">
                    <label className="font-mono text-[10px] uppercase tracking-wider text-neutral-400">Atelier Encrypted Email</label>
                    <input 
                      type="email" 
                      name="email"
                      required
                      value={checkoutData.email}
                      onChange={handleInputChange}
                      data-testid="checkout-email-input"
                      className="w-full px-4 py-2.5 bg-black/40 border border-white/10 rounded-sm text-xs font-mono text-white focus:outline-none focus:border-amber-500/60"
                    />
                    {checkoutErrors.email && <p className="text-[10px] text-red-400 font-mono">{checkoutErrors.email}</p>}
                  </div>

                  {/* Address */}
                  <div className="space-y-1.5">
                    <label className="font-mono text-[10px] uppercase tracking-wider text-neutral-400">Priority Shipping Address</label>
                    <textarea 
                      name="address"
                      required
                      rows={2}
                      value={checkoutData.address}
                      onChange={handleInputChange}
                      data-testid="checkout-address-input"
                      className="w-full px-4 py-2.5 bg-black/40 border border-white/10 rounded-sm text-xs font-mono text-white focus:outline-none focus:border-amber-500/60 resize-none"
                    />
                    {checkoutErrors.address && <p className="text-[10px] text-red-400 font-mono">{checkoutErrors.address}</p>}
                  </div>

                  {/* Card Credentials Grid */}
                  <div className="grid grid-cols-1 sm:grid-cols-12 gap-4">
                    
                    <div className="sm:col-span-6 space-y-1.5">
                      <label className="font-mono text-[10px] uppercase tracking-wider text-neutral-400">Credit Card Number</label>
                      <div className="relative">
                        <CreditCard className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-neutral-600" />
                        <input 
                          type="text" 
                          name="cardNum"
                          required
                          placeholder="4111 2222 3333 4444"
                          maxLength={19}
                          value={checkoutData.cardNum}
                          onChange={handleInputChange}
                          data-testid="checkout-card-input"
                          className="w-full pl-10 pr-4 py-2.5 bg-black/40 border border-white/10 rounded-sm text-xs font-mono text-white focus:outline-none focus:border-amber-500/60"
                        />
                      </div>
                      {checkoutErrors.cardNum && <p className="text-[10px] text-red-400 font-mono">{checkoutErrors.cardNum}</p>}
                    </div>

                    <div className="sm:col-span-3 space-y-1.5">
                      <label className="font-mono text-[10px] uppercase tracking-wider text-neutral-400">Expiry (MM/YY)</label>
                      <input 
                        type="text" 
                        name="expiry"
                        required
                        placeholder="12/28"
                        maxLength={5}
                        value={checkoutData.expiry}
                        onChange={handleInputChange}
                        data-testid="checkout-expiry-input"
                        className="w-full px-4 py-2.5 bg-black/40 border border-white/10 rounded-sm text-xs font-mono text-white focus:outline-none focus:border-amber-500/60 text-center"
                      />
                      {checkoutErrors.expiry && <p className="text-[10px] text-red-400 font-mono">{checkoutErrors.expiry}</p>}
                    </div>

                    <div className="sm:col-span-3 space-y-1.5">
                      <label className="font-mono text-[10px] uppercase tracking-wider text-neutral-400">CVV Security</label>
                      <input 
                        type="password" 
                        name="cvv"
                        required
                        placeholder="•••"
                        maxLength={3}
                        value={checkoutData.cvv}
                        onChange={handleInputChange}
                        data-testid="checkout-cvv-input"
                        className="w-full px-4 py-2.5 bg-black/40 border border-white/10 rounded-sm text-xs font-mono text-white focus:outline-none focus:border-amber-500/60 text-center"
                      />
                      {checkoutErrors.cvv && <p className="text-[10px] text-red-400 font-mono">{checkoutErrors.cvv}</p>}
                    </div>

                  </div>

                </div>

                <div className="pt-4 border-t border-white/5 flex flex-col sm:flex-row gap-4 items-center justify-between">
                  <div className="flex items-center gap-1.5 text-[10px] text-neutral-500 font-mono">
                    <Lock className="h-3.5 w-3.5 text-amber-500" />
                    <span>256-bit AES protection active</span>
                  </div>
                  
                  <button
                    type="submit"
                    data-testid="checkout-submit-btn"
                    className="w-full sm:w-auto px-8 py-3 bg-amber-500 hover:bg-amber-400 text-black font-mono text-xs uppercase tracking-widest font-bold rounded-sm transition-all duration-300"
                  >
                    Confirm Secure Reservation
                  </button>
                </div>
              </form>
            )}

            {/* STEP 2: Elegant Status Glitch Loader */}
            {checkoutStep === 2 && (
              <div className="py-16 text-center space-y-6">
                <div className="relative mx-auto h-12 w-12 flex items-center justify-center">
                  <div className="absolute inset-0 rounded-full border-2 border-t-amber-500 border-r-transparent border-b-transparent border-l-transparent animate-spin" />
                  <Lock className="h-5 w-5 text-amber-400 animate-pulse" />
                </div>
                <div className="space-y-2">
                  <h4 className="font-mono text-xs text-white uppercase tracking-[0.2em]">Transaction in Cryptographic Flight</h4>
                  <p className="font-mono text-[10px] text-amber-300/80 italic animate-pulse">{checkoutLoadingText}</p>
                </div>
              </div>
            )}

            {/* STEP 3: Majestic Certificate Order Confirmation Screen */}
            {checkoutStep === 3 && (
              <div className="space-y-8 animate-fade-in">
                
                {/* Visual authenticity seal */}
                <div className="mx-auto h-16 w-16 bg-amber-500/10 border border-amber-500/40 rounded-full flex items-center justify-center">
                  <ShieldCheck className="h-8 w-8 text-amber-400" />
                </div>

                <div className="text-center space-y-2">
                  <span className="text-[9px] uppercase tracking-[0.25em] font-mono text-amber-400">Lineage Sealed</span>
                  <h3 className="text-3xl font-serif font-light text-white">Authenticity Confirmed</h3>
                  <p className="text-xs text-neutral-400 font-light max-w-md mx-auto leading-relaxed">
                    Thank you, <span className="text-white font-medium">{checkoutData.name}</span>. Your private slot in the Florentine workshop has been securely locked.
                  </p>
                </div>

                {/* Secure certificate card */}
                <div className="border border-amber-500/20 bg-amber-500/5 p-6 rounded-sm space-y-4 font-mono text-xs text-left text-neutral-300">
                  <div className="flex items-center justify-between border-b border-amber-500/10 pb-3">
                    <span className="text-[9px] uppercase tracking-wider text-amber-400 font-bold">Proof of Origin License</span>
                    <span className="text-white">MDE-9824-2026</span>
                  </div>
                  
                  <div className="space-y-1.5 text-[10px]">
                    <p><span className="text-neutral-500">RECIPIENT:</span> {checkoutData.name}</p>
                    <p><span className="text-neutral-500">DISPATCH DESTINATION:</span> {checkoutData.address}</p>
                    <p><span className="text-neutral-500">CRAFTING TIMELINE:</span> 14 business days</p>
                    <p><span className="text-neutral-500">AUTHORIZED ATELIER LOG:</span> Secure signature logged at <a href="https://api-prod-new.tagmango.com" className="text-amber-400 underline">api-prod-new.tagmango.com</a></p>
                  </div>
                </div>

                <div className="text-center">
                  <button
                    onClick={() => { setIsCheckoutOpen(false); setCheckoutStep(1); }}
                    data-testid="checkout-success-close"
                    className="px-8 py-3 bg-white text-black font-mono text-xs uppercase tracking-widest font-bold rounded-sm hover:bg-neutral-200 transition-colors"
                  >
                    Return to Atelier
                  </button>
                </div>

              </div>
            )}

          </div>
        </div>
      )}

    </div>
  );
}
